export const CompanyActions = {
  TOGGLE_LOADER: '@CompanyActions/TOGGLE_LOADER',
  TOGGLE_ERROR: '@CompanyActions/TOGGLE_ERROR',
  UPDATE_DATA: '@CompanyActions/UPDATE_DATA',
  UPDATE_SIGNUP: '@CompanyActions/UPDATE_SIGNUP',
  SET_AVAILABLE_PLANS: '@CompanyActions/SET_AVAILABLE_PLANS',
};

const companyState = {
  isLoading: false,
  isError: false,
  companyData: undefined,
  planData: undefined,
  pnfamData: {
    alimentos_saudaveis: 0,
    ansiedade: 0,
    avg: 0,
    centro_costas: 0,
    cervical: 0,
    empresa: '',
    estresse: 0,
    frituras_gorduras: 0,
    frutas: 0,
    id_empresa: '',
    lanches: 0,
    lombar: 0,
    peitoral: 0,
    ombro_esquerdo: 0,
    ombro_direito: 0,
    perna_esquerda: 0,
    perna_direita: 0,
    punho_esquerdo: 0,
    punho_direito: 0,
    pe_esquerdo: 0,
    pe_direito: 0,
    qtd_cansaco_fisico: 0,
    qtd_colaboradores: 0,
    qtd_dor_cabeca: 0,
    qtd_melhorar_alimentacao: 0,
    qtd_plano_alimentacao: 0,
    qtd_respostas: 0,
    qualidade_alimentacao: 0,
    qualidade_sono: 0,
    seq: 0,
  },
  classSummary: {
    nota_aula: 0,
    nota_profissional: 0,
    nota_dificuldade: 0,
    nota_qualidade: 0,
  },
  companySignUp: {
    nome: '',
    cnpj: '',
    email: '',
    telefone: '',
    contato: '',
    id_plano: '',
    segunda: 0,
    terca: 0,
    quarta: 0,
    quinta: 0,
    sexta: 0,
    sabado: 0,
    domingo: 0,
    horario: '',
    forma_pagamento: '',
  },
  availablePlans: [],
};

const CompanyReducer = (state = companyState, action) => {
  switch (action.type) {
    case CompanyActions.TOGGLE_LOADER:
      return { ...state, isLoading: !state.isLoading };
    case CompanyActions.TOGGLE_ERROR:
      return { ...state, isError: !state.isError };
    case CompanyActions.UPDATE_DATA:
      return { ...state, [action.dataType]: action.dataValue };
    case CompanyActions.UPDATE_SIGNUP:
      return { ...state, companySignUp: action.companySignUp };
    case CompanyActions.SET_AVAILABLE_PLANS:
      return { ...state, availablePlans: action.availablePlans };
    default:
      return { ...state };
  }
};

export default CompanyReducer;
